module.exports = __webpack_public_path__ + "img/icon-eye.0ee53534.svg";